import { TimelineData } from "./components/timeline/Timeline";
import adventure3DData from "./data/adventure3DData";
import creationOfMoonARData from "./data/creationOfMoonARData";
import discoverWeek2DData from "./data/discoverWeek2DData";
import legendOfCloudsData from "./data/legendOfCloudsData";
import softDrinkOnlyData from "./data/softDrinkOnlyData";
import spaceVRData from "./data/spaceVRData";
import test3DData from "./data/test3DData";
import zeldaNarrativeSeriesData from "./data/zeldaNarrativeSeriesData";

const portfolioData: TimelineData[] = [
  spaceVRData,
  adventure3DData,
  creationOfMoonARData,
  zeldaNarrativeSeriesData,
  test3DData,
  softDrinkOnlyData,
  legendOfCloudsData,
  discoverWeek2DData,
];

export default portfolioData;
